export default __webpack_public_path__ + "static/media/user01.3d6f1831.jpg";